import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * StatusBadge Component
 * Displays a badge with a colored dot matching filter pill colors
 */
import { cn } from '../utils/cn.js';
import { SEVERITY_COLORS, STATUS_COLORS } from '../tokens/colors.js';
export function StatusBadge({ label, colorKey, variant = 'status', className }) {
    const colors = variant === 'severity' ? SEVERITY_COLORS : STATUS_COLORS;
    const color = colors[colorKey] || '#6b7280';
    return (_jsxs("span", { "data-testid": "status-badge", className: cn('inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium', 'bg-gray-50/80 dark:bg-slate-700/80 shadow-sm shadow-gray-900/5 text-gray-700 dark:text-slate-200 whitespace-nowrap', className), children: [_jsx("span", { className: "w-2 h-2 rounded-full flex-shrink-0", style: { backgroundColor: color } }), label] }));
}
//# sourceMappingURL=StatusBadge.js.map